import React, { useEffect } from "react";
import IndustriesSection from "../components/sections/IndustriesSection";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { INDUSTRIES } from "../data/site";

export default function IndustriesPage() {
  useEffect(() => {
    document.title = "Industries — Weldmatix Fusion";
  }, []);

  return (
    <div data-testid="page-industries" className="bg-[#FFFFFF] pt-32 md:pt-40">
      <section className="max-w-7xl mx-auto px-6 lg:px-12 pb-12">
        <div className="eyebrow mb-4">// Industries Served</div>
        <h1 className="font-display uppercase tracking-tight text-slate-900 text-5xl md:text-7xl leading-[0.95]">
          Trusted across the<br /><span className="text-[#0EA5E9]">world's critical</span> industries
        </h1>
        <p className="mt-6 max-w-2xl text-[#475569] leading-relaxed">
          Weldmatix systems are deployed across {INDUSTRIES.length} core industries —
          delivering metallurgical integrity, automation reliability, and engineering
          accountability for the world's most demanding operators.
        </p>
      </section>

      <IndustriesSection />

      <section className="border-t border-[#E2E8F0]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <h3 className="font-display uppercase text-slate-900 text-3xl md:text-5xl tracking-tight leading-[0.95] max-w-2xl">
            Your industry, our<br /><span className="text-[#0EA5E9]">automation expertise.</span>
          </h3>
          <Link to="/contact" data-testid="industries-cta-contact" className="group inline-flex items-center gap-4 bg-[#0EA5E9] hover:bg-[#0284C7] text-white px-6 py-4 text-sm uppercase tracking-[0.2em]">
            Talk to an Engineer <ArrowUpRight className="w-5 h-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition" />
          </Link>
        </div>
      </section>
    </div>
  );
}
